var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./PanelPopup.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-48363a34\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PanelPopup.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/PanelPopup/PanelPopup.vue.html
// module id = VP96
// module chunks = 2